<div class="row">
  <div [ngClass]="multiPageCheckout() ? 'col-md-12 col-lg-12 col-xs-12' : 'col-md-12 col-lg-12 col-xs-12'">
    <div class="basket-order-reference">
      <div class="section">
        <form [formGroup]="form" (ngSubmit)="submitForm()">
          <div class="row">
            @if (showSuccessMessage) {
            <div class="col-md-12">
              <ish-success-message message="checkout.orderReferenceId.success.message" [toast]="false" />
            </div>
            }
            <div [ngClass]="multiPageCheckout() ? 'col-md-9 col-xs-8' : 'col-md-8 col-xs-8'">
              <formly-form [form]="form" [fields]="fields" [model]="model" />
            </div>
            <div [ngClass]="multiPageCheckout() ? 'col-md-3 col-xs-4 pl-md-0' : 'col-md-4 col-xs-4 pl-md-0'">
              <button type="submit" class="btn btn-secondary custom-apply-btn" [disabled]="disabled">
                {{ 'checkout.orderReferenceId.apply.button.label' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
